import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import CloseIcon from '../../CloseIcon/CloseIcon';
import MobileDropdown from './MobileDropdown';
import Modal from '../../Modal/RecieverDomElements';
import { BLACK, MOBILE_PADDING, WHITE } from '../../../styles/variables.style';

const FilterMenuWrapper = styled.div`
  background-color: ${WHITE};
  bottom: 0;
  display: flex;
  flex-direction: column;
  left: 0;
  opacity: ${({ show }) => (show ? 1 : 0)};
  padding: 22px 0;
  position: fixed;
  right: 0;
  top: 0;
  transition: opacity 200ms ease-in-out, visibility 200ms ease-in-out;
  visibility: ${({ show }) => (show ? 'visible' : 'hidden')};
  z-index: 999999999;
`;

const CloseButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 0 ${MOBILE_PADDING}px;
`;

const CloseButton = styled.button`
  cursor: pointer;
  background: transparent;
  border: none;
  margin-bottom: 1em;
  padding: 0;
`;

const FilterTypeList = styled.div`
  overflow: auto;
  flex: 1;
`;

const FilterButtonWrapper = styled.div`
  padding: 0 ${MOBILE_PADDING}px;
  display: flex;
  justify-content: space-between;
  margin-top: 22px;
`;

const ClearButton = styled.button`
  height: 45px;
  line-height: 45px;
  background-color: ${WHITE};
  border: 1px solid ${BLACK};
  flex: 1;
  text-align: center;
  margin-right: 8px;

  span {
    text-transform: uppercase;
    font-weight: 800;
    font-size: 12px;
    letter-spacing: 1px;
  }
`;

const ApplyButton = ClearButton.extend`
  background-color: ${BLACK};
  color: ${WHITE};
  margin-right: 0;
`;

class MobileModal extends React.Component {
  static propTypes = {
    close: PropTypes.func.isRequired,
    copy: PropTypes.shape().isRequired,
    dropdowns: PropTypes.arrayOf(PropTypes.shape()).isRequired,
    open: PropTypes.bool.isRequired,
  };

  state = {
    dropdowns: this.props.dropdowns,
  };

  componentDidUpdate = prevProps => {
    const { dropdowns } = this.props;
    if (JSON.stringify(prevProps.dropdowns) !== JSON.stringify(dropdowns)) {
      this.setState({ dropdowns });
    }
  };

  handleApply = () => {
    this.props.close(this.state.dropdowns);
  };

  handleClearFilters = () => {
    this.props.close(
      this.state.dropdowns.map(dropdown => ({
        ...dropdown,
        active: [],
      }))
    );
  };

  handleClose = () => {
    this.props.close();
  };

  handleDropdownUpdate = (active, id) => {
    const { dropdowns } = this.state;
    this.setState({
      dropdowns: dropdowns.map(dropdown => {
        if (dropdown.id === id) {
          return { ...dropdown, active };
        }
        return dropdown;
      }),
    });
  };

  render = () => {
    const { dropdowns } = this.state;
    const { copy, open } = this.props;

    return (
      <Modal>
        <FilterMenuWrapper show={open}>
          <CloseButtonWrapper>
            <CloseButton onClick={this.handleClose}>
              <CloseIcon />
            </CloseButton>
          </CloseButtonWrapper>

          <FilterTypeList>
            {dropdowns.map(dropdown => (
              <MobileDropdown key={dropdown.id} {...dropdown} onUpdate={this.handleDropdownUpdate} />
            ))}
          </FilterTypeList>

          <FilterButtonWrapper>
            <ClearButton onClick={this.handleClearFilters}>{copy.clear_all}</ClearButton>
            <ApplyButton onClick={this.handleApply}>{copy.apply}</ApplyButton>
          </FilterButtonWrapper>
        </FilterMenuWrapper>
      </Modal>
    );
  };
}

export default MobileModal;



// WEBPACK FOOTER //
// ./src/components/DropdownMenu/MobileDropdown/MobileModal.js